import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import './SignupLoginForm.css'; // Ensure you have this CSS file for custom styles
import INDIANFLAG from '../../Assets/images/indian-flag.png';
import { VERIFY_OTP } from '../../constants/route-path';
import apis from '../../Services/api-services';
import { useDispatch } from 'react-redux';
import { userActions } from '../../Store/userSlice';
import { ALERT_TYPES } from '../../constants/app-constants';
import { RotatingLines } from 'react-loader-spinner';
import LoginWrapperNew from '../../components/loginWrapperNew';
import { useTranslation } from 'react-i18next';
import { TRANSLATIONS } from '../../Utils/translations';
import SHIELD from '../../Assets/images/shield.svg'

const SignupLoginForm = (props) => {
  const { t } = useTranslation();
  const [mobile, setMobile] = useState('');
  const [errors, setErrors] = useState({});
  const [openSnackbar, setOpenSnackbar] = useState(false); // State to control error Snackbar
  const [alertMsg, setAlertmsg] = useState('');
  const [alertType, setAlertType] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const regexOnlyNumber = /^[0-9]*$/;
  const wrapperProps = {
    openSnackbar,
    setOpenSnackbar,
    setAlertmsg,
    alertType,
    alertMsg,
  };

  const validateForm = () => {
    const newErrors = {};
    if (!mobile) {
      newErrors.mobile = 'Mobile number is required';
    } else if (!/^\d{10}$/.test(mobile)) {
      newErrors.mobile = 'Enter a valid 10-digit Indian mobile number';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    if (!validateForm()) return;
    const payload = { mobile, channel: 'android' };
    setLoading(true);
    apis.user.sendOtp(payload).then((response) => {
      setLoading(false);
      if (response.status === 200) {
        dispatch(userActions.setUserDetails({ mobile }));

        navigate(VERIFY_OTP);
      } else {
        setAlertmsg('Login Failed!');
        setAlertType(ALERT_TYPES.error);
        setOpenSnackbar(true);
        console.error('Signup failed:', response);
      }
    });
  };

  const handleInputChange = (value, id) => {
    let newErrors = {};
    switch (id) {
      case 'mobile':
        if (regexOnlyNumber.test(value) && value.length < 11) {
          setMobile(value);
        }
        break;
      default:
        break;
    }
    setErrors(newErrors);
  };

  return (
    <LoginWrapperNew {...wrapperProps} firstPage={true}>
      <div className="signup-login-form-content">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            height: '65vh',
          }}
        >
      <Box>
          <Typography
            sx={{
              fontWeight: 600,
              color: '#1B2538',
              fontSize: '28px',
              pt: '12px',
              pb: '30px',
              // letterSpacing:'-0.5px',
              letterSpacing:'-0.5px',
              lineHeight:'48px'
            }}
          >
            {t(TRANSLATIONS.SUB_TITLES.LETS_BEGIN_WITH_PHONE_NUMBER)}
          </Typography>
          {/* <Typography
            sx={{
              fontWeight: 500,
              color: '#474747',
              fontSize: '14px',
              mb:2,
              display:'flex',
              flexDirection:'row',
              alignItems:'center',
              justifyContent:'flex-start'
            }}
          >
           <img src={SHIELD} alt='icon' width={15} height={16} style={{marginRight:'5px',display:'inline-block',opacity:0.5}} /> vREfyd exists to protect you from spam.
          </Typography> */}
          <Typography
            sx={{
              fontWeight: 500,
              color: '#0F1824',
              fontSize: '12px',
              mb:'6px',
            }}>
              Enter mobile number
            </Typography>
          <div
            className={`input-container ${errors.mobile ? 'input-error' : ''}`}
          >
            {/* <img src={INDIANFLAG} alt="India Flag" className="flag-icon" /> */}
            <span className="country-code">+91</span>
            <input
              type="number"
              placeholder="9876543210"
              id="mobile"
              value={mobile}
              disabled={loading}
              onChange={(e) => handleInputChange(e.target.value, e.target.id)}
              className={`signup-inputs `}
              autocomplete="off"
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleSubmit();
                }
              }}
            />
          </div>
          <span className="signup-error-msg">{errors.mobile}</span>
          </Box>
          <Box sx={{display:'flex',flexDirection:'column',width:'100%'}}>
            <Typography sx={{fontWeight:400,fontSize:'12px',color:'#6C7480',textAlign:'center'}}>Your alerts and login codes will be sent to WhatsApp.</Typography>
          <Button
            type="submit"
            variant="contained"
            className="signup-btn"
            color="primary"
            onClick={() => {
              if (!loading) {
                handleSubmit();
              }
            }}
            sx={{ textTransform: 'capitalize', gap: '4px',boxShadow:'none' }}
            fullWidth
          >
            {loading
              ? t(TRANSLATIONS.TITLES.SUBMITTING)
              : t(TRANSLATIONS.TITLES.SUBMIT)}

            <RotatingLines
              visible={loading}
              height="24"
              width="24"
              strokeColor="#fff"
              strokeWidth="5"
              animationDuration="0.7"
            />
          </Button>
          </Box>
         
        </Box>
      </div>
    </LoginWrapperNew>
  );
};

export default SignupLoginForm;
